module.exports = __webpack_public_path__ + "img/Picture1.067e5726.png";